const debounce = {};

export default (name, func, wait = 500) => {
  if (debounce[name]) {
    clearTimeout(debounce[name]);
  }
  debounce[name] = setTimeout(() => {
    func();
    delete debounce[name];
  }, wait);
};
